export interface PersistedUint8Array {
  __type: "Uint8Array";
  value: number[];
}

export const encodeUint8Array = (u8: Uint8Array): PersistedUint8Array => ({
  __type: "Uint8Array",
  value: Array.from(u8),
});

export const decodeUint8Array = (e: PersistedUint8Array | undefined): Uint8Array | undefined => {
  if (!e) return undefined;
  if (typeof e === "object" && Array.isArray(e.value)) {
    return new Uint8Array(e.value);
  }
  return undefined;
};
